
    import '/mnt/src/components/Switch/index.md?watch=parent';
    export const demoIndex = {
  ids: ["switch-demo-comprehensivedemo"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Switch/index.md?type=demo')
};